var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '@/Shared/Icon';
import { getButtonVariant } from './data';
export const Button = (props) => {
    const { type = 'button', isDisabled = false, isLoading = false, onClick = () => { }, variant = 'confirm', className = '', children, icon = '', iconClasses = '' } = props, rest = __rest(props, ["type", "isDisabled", "isLoading", "onClick", "variant", "className", "children", "icon", "iconClasses"]);
    const DEFAULT_CLASSES = 'text-white flex rounded py-2 px-4 focus::outline-none focus:shadow-outline';
    const DISABLED_CLASSES = 'bg-gray-500';
    const variantStyles = getButtonVariant(variant);
    const classList = `${DEFAULT_CLASSES} ${variantStyles} ${className} ${isDisabled ? DISABLED_CLASSES : ''}`;
    return (React.createElement("button", Object.assign({ disabled: isDisabled }, rest, { onClick: onClick, className: classList, type: type }),
        isLoading && React.createElement("div", { className: `mr-2 btn-spinner` }),
        icon && React.createElement(Icon, { name: icon, className: `mr-2 ${iconClasses}` }),
        children));
};
export default Button;
